import { connect } from 'react-redux';
import ChunkBookmarkPopoverTrigger from './ChunkBookmarkPopoverTrigger';

import * as bookmarkActions from 'edrolo/domains/bookmarks/actions';

const mapDispatchToProps = (dispatch, ownProps) => ({
  saveBookmark: (bookmarkData) =>
    dispatch(
      bookmarkActions.saveBookmark(ownProps.chunkId.toString(), bookmarkData)
    ),
  removeBookmark: () =>
    dispatch(
      bookmarkActions.removeBookmark(
        ownProps.chunkId.toString(),
        ownProps.bookmark
      )
    ),
});

export default connect(null, mapDispatchToProps)(ChunkBookmarkPopoverTrigger);
